export default "__VITE_ASSET__Bemkiy9l__"